import { useQuery, UseQueryOptions } from 'react-query';

import { MyVisitsPopupResponse, VisitsApi } from 'api/VisitsApi';

const POPUP_VISITS_QUERY_KEY = 'popup-visits-query';

export const useMyVisitsPopupQuery = (
  queryOptions?: UseQueryOptions<MyVisitsPopupResponse>
) => {
  return useQuery<MyVisitsPopupResponse>(
    POPUP_VISITS_QUERY_KEY,
    VisitsApi.fetchMyVisitsPopup,
    {
      retry: false,
      cacheTime: 0,
      ...queryOptions,
    }
  );
};
